
// CHART NOT USED. WHEN USED, CREATE A SERVICE TO GET DATA
import { Vue, Component, Prop } from "vue-property-decorator";
import axios from "axios";
// Entities
import {
  Company,
  Profile,
  Occupation,
  OccupationByTypology,
} from "@/entities/index";

@Component
export default class Chart6 extends Vue {
  @Prop() readonly warehouseCode!: string;
  client = this.company.codeLogistic || this.profile.company.codeLogistic;
  integrateStepZero = this.company.integrateStepZero;
  step = 1;

  occupationData: number[] = [];
  occupationOptions = {
    labels: this.$t("dataDashboard.charts.chart6.labels"),
    colors: ["#154077", "#aabb00"],
  };

  occupationByTypologyData: number[] = [];
  occupationByTypology = {
    labels: this.$t("dataDashboard.charts.chart7.labels"),
    colors: ["#154077", "#aabb00"],
  };

  get profile(): Profile {
    return this.$store.getters.profile;
  }

  get company(): Company {
    return this.$store.getters.company;
  }

  async getOccupation(): Promise<void> {
    const { occupation } = (
      await axios.post(`/api/occupation`, {
        client: this.client,
        warehouse: this.warehouseCode,
      })
    ).data as Occupation;
    this.occupationData = occupation;
  }

  async getOccupationByTypology(): Promise<void> {
    const { occupationByTypology } = (
      await axios.post(`/api/occupation-by-typology`, {
        client: this.client,
        warehouse: this.warehouseCode,
      })
    ).data as OccupationByTypology;
    this.occupationByTypologyData = occupationByTypology;
  }
}
